import type { ScratchSymbol } from '../../model/scratch/ScratchTypes';

/**
 * Default 5-symbol pool for the scratch demo. Theme-agnostic glyphs that
 * read at any size. Five symbols is the floor — fewer makes a "lose" board
 * impossible by pigeonhole over a 9-cell grid.
 */
export const DEFAULT_SCRATCH_SYMBOLS: readonly ScratchSymbol[] = [
  { id: 'coin', glyph: '💰', tint: 0xfff59d },
  { id: 'gem', glyph: '💎', tint: 0x9be7ff },
  { id: 'star', glyph: '⭐', tint: 0xffe066 },
  { id: 'clover', glyph: '🍀', tint: 0x86d986 },
  { id: 'cherry', glyph: '🍒', tint: 0xff6b9d },
];
